import { Page } from "@/models/page-models/Page";

export const MonthlyTargetByQuantity: Page = {
  "path": "monthly-target-quantity",
  "name": "Product Target KG",
  "props": {
    "data":{
      "title": "Product Target KG",
      "printable": "FALSE",
      "url": "monthly-target-quantity",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.month",
                  "label": "Select Month",
                  "disabled": "FALSE",
                  "items": "[\"January\",\"February\",\"March\",\"April\",\"May\",\"June\",\"July\",\"August\",\"September\",\"October\",\"November\",\"December\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.year",
                  "label": "Select Year",
                  "disabled": "FALSE",
                  "items": "[2023,2024,2025,2026,2027]",
                  "dropdownType": "static"
                },
                {
                  "type": "button",
                  "label": "Update",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getMonthlyTargetQuantities",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/order/get-monthly-target-report-quantity",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.monthlyTargetQuantities",
                        "arg3Key": "postData",
                        "arg3Value": "formData"
                      },
                      "name": "getMonthlyTargetQuantities"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            },
            {
              "name": "2",
              "pageItems": [
                {
                  "type": "monthlyTarget",
                  "monthlyTargetDataVariable": "fetchedData.monthlyTargetQuantities.data",
                  "targetType": "Quantity"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyQueryParams",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getQueryParams",
          "arg2Key": "destinationKey",
          "arg2Value": "formData",
          "arg3Key": "append",
          "arg3Value": "TRUE",
          "arg4Key": "destinationKeyType",
          "arg4Value": "Object"
        },
        "name": "copyQueryParams"
      },
      {
        "executionOrder": 2,
        "pageFunction": {
          "name": "getMonthlyTargetQuantities",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v1/order/get-monthly-target-report-quantity",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.monthlyTargetQuantities",
          "arg3Key": "postData",
          "arg3Value": "formData"
        },
        "name": "getMonthlyTargetQuantities"
      }
    ],
    "functions": [
      {
        "name": "getQueryParams",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "year": "fn(CONDITIONAL,{{__query.year}},{{__query.year}},{{CURRENT_YEAR}})",
          "month": "fn(CONDITIONAL,{{__query.month}},{{__query.month}},{{CURRENT_MONTH_NAME}})"
        },
        "useFormula": true
      }
    ]
  },
  "forRole": "GENERAL_MANAGER",
  "visible": true,
  "menuGroup": "Reports"
}